import { Country } from './country';
import { Marketplace } from './marketplace';
import { State } from './state';
import { Tag } from './tag';

export const customerFilterOptions = [Country, Marketplace, State, Tag];
